import type { CoupleSpace } from '../domain/types';
import { fromBase64Url, toBase64Url } from './base64url';
import {
  compressWire,
  decodeWireInvite,
  decodeWireMessage,
  decompressWire,
  encodeWireInvite,
  encodeWireMessage,
  type InvitePayload,
  type MessagePayload,
} from './compact';
import { decryptAesGcm, encryptAesGcm, ProtocolError } from './crypto';

export function assertShareableLength(url: string): void {
  if (url.length > 6000) {
    throw new ProtocolError('内容太长，无法稳定通过微信发送，请缩短说明或回复', 'URL_TOO_LONG');
  }
}

export function encodeInviteLink(baseUrl: string, space: CoupleSpace): string {
  if (space.memberId !== 'creator') {
    throw new ProtocolError('只有创建方可以生成邀请链接', 'INVITE_ROLE_INVALID');
  }
  const url = `${shareBase(baseUrl)}#invite=${toBase64Url(encodeWireInvite(space))}`;
  assertShareableLength(url);
  return url;
}

export function decodeInviteLink(token: string): InvitePayload {
  try {
    return decodeWireInvite(fromBase64Url(token));
  } catch (error) {
    if (error instanceof ProtocolError) throw error;
    throw new ProtocolError('链接内容格式无效', 'MALFORMED_PAYLOAD');
  }
}

export async function encodeMessageLink(baseUrl: string, payload: MessagePayload, key: Uint8Array): Promise<string> {
  const cipher = await encryptAesGcm(compressWire(encodeWireMessage(payload)), key);
  const url = `${shareBase(baseUrl)}#m=${toBase64Url(cipher)}`;
  assertShareableLength(url);
  return url;
}

export async function decodeMessageLink(token: string, key: Uint8Array): Promise<MessagePayload> {
  let cipher: Uint8Array;
  try {
    cipher = fromBase64Url(token);
  } catch {
    throw new ProtocolError('链接内容格式无效', 'MALFORMED_PAYLOAD');
  }
  const compressed = await decryptAesGcm(cipher, key);
  return decodeWireMessage(decompressWire(compressed));
}

function shareBase(baseUrl: string): string {
  const parsed = new URL(baseUrl);
  return `${parsed.origin}${parsed.pathname}`;
}
